import { derivePlan } from '@/components/tutor/planView.js'

export const resolveAdsUserKey = (value) => {
  if (!value || value === false) return ''
  return String(
    value.id
      ?? value.pk
      ?? value.profile_uuid
      ?? value.email
      ?? value.username
      ?? value.display_name
      ?? 'current',
  )
}

export const resolveAdsCheckKey = (userKey, entitlements, product = 'gusto') => {
  if (!userKey) return ''
  try {
    const identity = entitlements ? {
      plan: { uuid: entitlements.plan?.uuid, code: entitlements.plan?.code, is_free: entitlements.plan?.is_free },
      subscription: { uuid: entitlements.subscription?.uuid, status: entitlements.subscription?.status },
      products: entitlements.products,
      ...(product === 'nexo' ? { product, access: deriveAdsSubscriptionStatus(entitlements, product) } : {}),
    } : null
    return `${userKey}\u0001${JSON.stringify(identity)}`
  } catch {
    return `${userKey}\u0001${String(entitlements ?? '')}`
  }
}

export const deriveAdsSubscriptionStatus = (data, product = 'gusto') => {
  if (!data || typeof data !== 'object') return 'unknown'
  const grant = (data.products || data.entitlements?.products)?.[product]
  if (grant && typeof grant.ad_free === 'boolean') {
    const expired = product === 'nexo' && !grant.included_with_gusto && grant.own_access_until
      && new Date(grant.own_access_until).getTime() <= Date.now()
    return grant.ad_free && !expired ? 'paid' : 'free'
  }
  if (derivePlan(data)?.isPaid) return 'paid'
  const plan = data.plan || data.subscription?.plan
  if (plan?.is_free === true) return 'free'
  if (Object.hasOwn(data, 'subscription') && data.subscription === null && Object.hasOwn(data, 'plan') && data.plan === null) return 'free'
  if (['canceled', 'cancelled', 'incomplete_expired'].includes(data.subscription?.status)) return 'free'
  return 'unknown'
}

export const shouldHideAdsForSubscriptionState = ({ userKey, currentCheckKey, adsSubscriptionState }) => Boolean(userKey)
  && (
    adsSubscriptionState?.checkKey !== currentCheckKey
    || adsSubscriptionState?.status !== 'free'
  )
